import Typography from 'antd/es/typography';
import { Link } from 'react-router-dom';

import UnauthCard from '@components/UnauthCard';

const ResetPasswordSent = () => {
  return (
    <UnauthCard>
      <Typography.Title level={3}>{'Reset your password'}</Typography.Title>
      <div>
        <Typography.Text>
          {
            'If you have an account with us, you will receive an email with instructions on how to reset your password.'
          }
        </Typography.Text>
      </div>
      <div
        style={{
          marginTop: '1rem',
        }}
      >
        <Typography.Text>
          {'Back to '}
          <Link to="/auth/login">{'Login'}</Link>
        </Typography.Text>
      </div>
    </UnauthCard>
  );
};

export default ResetPasswordSent;
